(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory6Service", ['$ihttp', function ($ihttp) {
        let service = {
            getTextileModelCategory6: function (parms) {
                return $ihttp.post({
                    method: 2690,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2692,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
